import React from 'react';
import { Container, Typography, Box, Alert } from '@mui/material';
import IdentityRecoveryComponent from '../components/IdentityRecovery/IdentityRecoveryGuide';

const IdentityRecovery = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Box sx={{ textAlign: 'center', mb: 6 }}>
        <Typography variant="h2" component="h1" fontWeight="700" gutterBottom>
          Identity Recovery Guide
        </Typography>
        <Typography variant="h5" color="text.secondary">
          Step-by-step guidance to recover from identity theft
        </Typography>
      </Box>

      <Alert severity="warning" sx={{ mb: 4 }}>
        <strong>Legal Disclaimer:</strong> This information is provided for informational purposes only and does not constitute legal advice. 
        Identity theft recovery can involve complex legal issues. We strongly recommend consulting with a qualified attorney 
        who specializes in identity theft and consumer protection law to discuss your specific situation and legal rights.
      </Alert>

      <Alert severity="info" sx={{ mb: 4 }}>
        <strong>Important:</strong> This comprehensive guide will help you navigate the identity recovery process.
        Follow each step carefully and keep records of all communications.
      </Alert>

      <IdentityRecoveryComponent />
    </Container>
  );
};

export default IdentityRecovery;
